import * as React from 'react'
import { makeStyles } from '@material-ui/core';
import { Software } from '@portal/arq-portal-descarga-software';

export const DescargaComponent = (props:any) => {

  const useStyles = makeStyles(theme => ({
    linea: {
      padding: theme.spacing(1)
    },
    mainContainer:{
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'space-around',
      alignContent: 'stretch',
      alignItems: 'flex-start', 
      padding: '2%',
    }
  }));

  const classes = useStyles(props);

  return(
    <div className = {classes.mainContainer}>
      <Software />
    </div>
  );
  
}